module.exports = __webpack_public_path__ + "img/bg31.47e3c169.png";